import { AutocompleteApiModule } from '@common';

export class AutocompleteApi extends AutocompleteApiModule {
  public search(endpoint: string, searchParams: any) {
    return this.api.get(`${endpoint}`, { params: searchParams });
  }
}
